var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-youtube",
    fill: "none",
    viewBox: "0 0 17 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.575 3.918a3.48 3.48 0 0 0-3.48-3.48H4.2a3.48 3.48 0 0 0-3.48 3.48v4.141a3.48 3.48 0 0 0 3.48 3.48h8.895a3.48 3.48 0 0 0 3.48-3.48V3.918zm-5.23 2.381l-3.97 1.972c-.159.088-.688-.027-.688-.203V4.015c0-.18.534-.296.692-.203L11.2 5.89c.136.088.304.322.145.41z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-twitter",
    fill: "none",
    viewBox: "0 0 18 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.449 9.965c.544.884 1.39 1.217 2.13 1.438l.084.008.051.005c.071.007.163.017.264.04l.142.031.103.103-.354.354c.324-.323.474-.046.372.278l.023.015c-.13.2-.318.356-.498.477a4.18 4.18 0 0 1-.593.324c-.368.169-.756.301-1.008.387l-.06.021c-.475.17-.965.289-1.461.357.29.114.584.212.885.294h0c3.339.925 7.06.237 9.522-2.21h0c1.925-1.91 2.627-4.57 2.627-7.307 0-.275.168-.444.249-.513.043-.038.087-.067.11-.084l.03-.02a.78.78 0 0 0 .008-.005l.003-.003h0a6.28 6.28 0 0 0 .448-.382 7.49 7.49 0 0 1-.417.075l-.158-.987-.028.006s.016-.006.048-.03a1.5 1.5 0 0 0 .178-.156c.066-.066.13-.137.188-.204a9.216 9.216 0 0 1-.89.27.643.643 0 0 1-.632-.18l-.01-.012-.01-.012a1.063 1.063 0 0 0-.12-.122 3.219 3.219 0 0 0-.85-.523 2.928 2.928 0 0 0-1.295-.206h-.004 0a3.11 3.11 0 0 0-1.242.341 3.238 3.238 0 0 0-1.004.823v.002c-.284.346-.487.75-.595 1.184a3.309 3.309 0 0 0-.03 1.268l.008.042v.046c0 .016 0 .054-.003.09v.002a.526.526 0 0 1-.49.49.665.665 0 0 1-.155-.008c-2.714-.384-5.032-1.35-6.944-3.325-.141.413-.171.895-.091 1.386.111.686.426 1.32.848 1.72.135.127.275.255.422.387l1.116.998-1.492-.128a4.066 4.066 0 0 1-.864-.17 3.102 3.102 0 0 0 1.852 2.15l.01.004h0c.108.047.221.08.337.101l.011.983c-.254.051-.512.08-.771.087zm0 0a3.118 3.118 0 0 1-.184-.346c.071.034.143.066.216.095.177.077.363.132.553.166l.088-.492-.099-.49c-.07.014-.14.026-.21.035l-.01.002c-.232.031-.467.04-.7.025A3.602 3.602 0 0 1 1.46 6.424m-.03-.437c.009-.09.052-.123.131-.071.053.027.105.053.159.078l-.197-.005h-.01l-.082-.002zm0 0a2.378 2.378 0 0 0 .024.397l.001.005a.446.446 0 0 0 .465-.31c-.05-.02-.101-.04-.15-.062l-.25-.022h-.01l-.08-.008zm.533.11a3.745 3.745 0 0 1-.033-.013l.033.012zm0 0a3.2 3.2 0 0 0 .178.182h0c.143.135.289.268.442.406l.334-.373.042-.498a3.068 3.068 0 0 1-.333-.047l-.663.33zm7.21-1.312h0c.006 0 .007 0 0 0z",
    fill: "#000",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.253 2.967a.918.918 0 1 0-.008 1.836.918.918 0 0 0 .008-1.836zM8.183 4.145a3.846 3.846 0 1 0-.01 7.691 3.846 3.846 0 0 0 .01-7.691zm0 6.306a2.466 2.466 0 1 1 2.46-2.465 2.463 2.463 0 0 1-2.46 2.479v-.014z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.234 15.792H5.003a4.693 4.693 0 0 1-4.688-4.688V4.873A4.693 4.693 0 0 1 5.003.185h6.231a4.693 4.693 0 0 1 4.684 4.688v6.231a4.693 4.693 0 0 1-4.684 4.688zM5.003 1.644a3.224 3.224 0 0 0-3.22 3.22v6.231a3.224 3.224 0 0 0 3.22 3.22h6.231a3.228 3.228 0 0 0 3.22-3.22V4.873a3.228 3.228 0 0 0-3.22-3.22l-6.231-.009z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-line",
    fill: "none",
    viewBox: "0 0 2 81"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M.939 80.39V.315"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.4e58641bea6aa7d0ede223e861eaf077.svg";
export { ForwardRef as ReactComponent };